// extracted by mini-css-extract-plugin
export var createdDate = "_f5-1";
export var divider = "_f5-2";
export var headerDivider = "_f5-3";
export var messagesCard = "_f5-0";
export var messagesContainer = "_f5-7";
export var messagesContainerWrapper = "_f5-4";
export var pointerCapturingButtonBoxes = "_f5-a";
export var showLeftPanelButton = "_f5-9";
export var showMoreButton = "_f5-c";
export var showMoreButtonContainer = "_f5-b";
export var summaryTitle = "_f5-6";
export var systemMessageCardWrapper = "_f5-d";
export var topButtons = "_f5-8";
export var withPadding = "_f5-5";